import React from 'react';

/** Controls toggling the visible status of a modal,
 * and handles the accessibility concern of returning focus
 * to the toggle button when the modal closes. */
function useModalControl(_temp) {
  let {
    focusDelay = 0
  } = _temp === void 0 ? {} : _temp;
  const [show, setShow] = React.useState(false);
  const triggerRef = React.useRef();
  function returnFocus() {
    if (triggerRef.current) triggerRef.current.focus();
  }
  function openModal() {
    setShow(true);
  }
  function closeModal(_temp2) {
    let {
      shouldReturnFocus = true
    } = _temp2 === void 0 ? {} : _temp2;
    setShow(false);
    if (shouldReturnFocus) {
      setTimeout(() => returnFocus(), focusDelay);
    }
  }
  return {
    onClick: openModal,
    onClose: closeModal,
    ref: triggerRef,
    show
  };
}
export { useModalControl };